// Expiry is optional, if not set then cookie stays active till year 2035
import { serialize } from 'cookie'

import { FEATURES, MODULES } from '../constants/template-info'

import getCookieDomain from './getCookieDomain'
import isBrowser from './isBrowser'
import { captureException } from './sentryUtil'

// /**
//  * @deprecated Use EnhancedCookie utility instead:
//  * ```typescript
//  * import { getCookie } from '@src/utils/enhancedCookie'
//  * setCookie(key, value, {
//  *   isGlobal: true,
//  *   expires: new Date('2035-05-18'),
//  *   secure: true,
//  *   domain: getCookieDomain()
//  * })
//  * ```
//  */
const setCookie = (
  name: string,
  value: string | undefined | boolean,
  expiryMinutes: number | undefined = 400 * 24 * 60, // 400 days
  isSecure: boolean | undefined = false,
  subDomainSharing = true,
) => {
  console.warn('setCookie is deprecated. Use EnhancedCookie utility instead.')
  if (!isBrowser()) return
  try {
    const expiryInMs = expiryMinutes ? expiryMinutes * 60 * 1000 : 400 * 24 * 60 * 60 * 1000
    const cookieString = serialize(name, String(value), {
      path: '/',
      expires: expiryMinutes ? new Date(Date.now() + expiryInMs) : undefined,
      secure: isSecure,
      sameSite: 'lax',
      domain: subDomainSharing ? getCookieDomain() : undefined,
    })
    // eslint-disable-next-line @quince/no-direct-cookie
    document.cookie = cookieString
  } catch (error) {
    captureException('setCookie error', {
      module: MODULES.COOKIE_STORAGE,
      feature: FEATURES.SET_COOKIE,
      extraInfo: {
        // @i18n-ignore
        capturedFrom: 'set cookie function',
        cookieKey: name,
        cookieValue: value,
        errorDetail: JSON.stringify(error),
      },
    })
  }
}

export default setCookie
